"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SearchInputRoot = exports.SearchInputInput = exports.SearchInputClear = exports.SearchInputBox = exports.InputBackdrop = exports.Inner = void 0;
var _mui = require("@ori-ui/mui");
var _presentationUtils = require("@ori/presentation-utils");
var _getMobileCssVariable = require("../../utils/getMobileCssVariable");
var _constants = require("./constants");
const Inner = exports.Inner = (0, _mui.styled)('div')(({
  theme
}) => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  background: theme.palette.common.white,
  width: '100%',
  borderRadius: 100,
  [theme.breakpoints.up('md')]: {
    borderRadius: theme.spacing(5),
    margin: '0 auto',
    maxWidth: '900px'
  }
}));
const SearchInputRoot = exports.SearchInputRoot = (0, _mui.styled)('div', {
  shouldForwardProp: (0, _presentationUtils.shouldForwardProp)()
})(({
  isTopBannerVisible,
  isVisibleOnMobile,
  showSearchOnScroll,
  showOnlyOn,
  isFocused,
  theme
}) => ({
  background: theme.palette.common.white,
  boxSizing: 'border-box',
  display: isVisibleOnMobile ? 'flex' : 'none',
  height: _presentationUtils.SEARCH_INPUT_HEIGHT,
  justifySelf: 'center',
  left: 0,
  padding: theme.spacing(0, 3, 3, 3),
  position: 'fixed',
  top: (0, _getMobileCssVariable.getSearchInputTopAttribute)({
    isTopBannerVisible,
    showSearchOnScroll
  }),
  width: '100%',
  zIndex: isFocused ? theme.zIndex.appBar + 2 : theme.zIndex.speedDial,
  justifyContent: isVisibleOnMobile ? 'center' : undefined,
  [theme.breakpoints.up('md')]: {
    background: 'transparent',
    display: showOnlyOn === 'desktop' ? 'block' : 'none',
    height: _constants.SEARCH_INPUT_BOX_HEIGHT,
    padding: 0,
    position: 'static'
  }
}));
const SearchInputBox = exports.SearchInputBox = (0, _mui.styled)('div')(({
  theme
}) => ({
  alignItems: 'center',
  background: theme.palette.grey[100],
  borderRadius: 100,
  boxSizing: 'border-box',
  color: theme.palette.grey[600],
  display: 'flex',
  fontSize: '2.3rem',
  height: _constants.SEARCH_INPUT_BOX_HEIGHT,
  overflow: 'hidden',
  paddingLeft: theme.spacing(3),
  width: '100%',
  svg: {
    fill: theme.palette.text.primary
  },
  [theme.breakpoints.up('md')]: {
    height: _constants.SEARCH_INPUT_BOX_HEIGHT,
    visibility: 'visible'
  }
}));
const SearchInputInput = exports.SearchInputInput = (0, _mui.styled)('input')(({
  theme
}) => ({
  background: theme.palette.grey[100],
  border: 'none',
  color: theme.palette.text.primary,
  fontSize: '1.6rem',
  height: 'auto',
  lineHeight: 1.5,
  marginLeft: 8,
  width: '100%',
  textOverflow: 'ellipsis',
  '&:focus': {
    outline: 'none'
  },
  '&::placeholder': {
    color: theme.palette.grey.A700
  }
}));
const SearchInputClear = exports.SearchInputClear = (0, _mui.styled)(_mui.ButtonBase, {
  shouldForwardProp: (0, _presentationUtils.shouldNotForwardProp)(['isFocused'])
})(({
  isFocused,
  theme
}) => ({
  height: 23,
  marginRight: theme.spacing(3),
  width: 23,
  [theme.breakpoints.up('md')]: {
    fontSize: '2rem',
    marginRight: theme.spacing(2),
    visibility: 'hidden',
    ...(isFocused && {
      visibility: 'visible'
    })
  }
}));
const InputBackdrop = exports.InputBackdrop = (0, _mui.styled)(_mui.Backdrop)({
  position: 'fixed',
  zIndex: '-1',
  width: '100vw',
  height: '100vh'
});